import { useEffect, useState } from "react";
import { Cast, Tv, ChevronLeft, ChevronRight, Car, Tag } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useCast } from "./CastButton";

const NS = "urn:x-cast:com.myvelocity.tv";

export default function CastSiteButton({ className = "", compact = false }) {
  const [cfg, setCfg] = useState(null);
  const { state, stop } = useCast();
  useEffect(() => { api.get("/cast/config").then((r) => { setCfg(r.data); window.__castAppId = r.data.app_id || null; window.dispatchEvent(new Event("castappid")); }).catch(() => setCfg({ app_id: null })); }, []);
  const connected = state === "connected";
  const send = (msg) => { try { window.cast.framework.CastContext.getInstance().getCurrentSession()?.sendMessage(NS, msg); } catch { /* ignore */ } };
  const openTvMode = () => { window.open("/tv?help=1", "_blank", "noopener"); toast.message("TV Mode opened — use Chrome ⋮ → Cast → Cast tab to put it on your TV"); };
  const castSite = async () => {
    if (!cfg?.app_id || state === "unavailable") return openTvMode();
    try {
      const ctx = window.cast.framework.CastContext.getInstance();
      await ctx.requestSession();
      send({ view: "carousel" });
      toast.success(`MY VELOCITY is on ${ctx.getCurrentSession().getCastDevice().friendlyName}`);
    } catch (e) { if (e !== "cancel") { toast.error(e === "receiver_unavailable" ? "No Chromecast found — opening TV Mode instead" : "Could not cast — opening TV Mode"); openTvMode(); } }
  };
  if (connected && cfg?.app_id) {
    return (
      <span className={`inline-flex items-center gap-1 ${className}`} data-testid="cast-site-controls">
        <button onClick={() => send({ prev: true })} className="p-1 text-cyan-300 hover:text-white" aria-label="Previous car" data-testid="cast-site-prev"><ChevronLeft className="w-4 h-4" /></button>
        <button onClick={() => send({ view: "carousel" })} className="p-1 text-cyan-300 hover:text-white" aria-label="Featured cars" data-testid="cast-site-cars"><Car className="w-4 h-4" /></button>
        <button onClick={() => send({ view: "sales" })} className="p-1 text-cyan-300 hover:text-white" aria-label="Cars for sale" data-testid="cast-site-sales"><Tag className="w-4 h-4" /></button>
        <button onClick={() => send({ next: true })} className="p-1 text-cyan-300 hover:text-white" aria-label="Next car" data-testid="cast-site-next"><ChevronRight className="w-4 h-4" /></button>
        <button onClick={stop} className="ml-1 text-xs text-cyan-300 hover:underline" data-testid="cast-site-stop">Stop</button>
      </span>
    );
  }
  return (
    <button onClick={castSite} className={`inline-flex items-center gap-1.5 whitespace-nowrap text-slate-300 hover:text-white transition-colors text-sm font-medium ${className}`} title={cfg?.app_id ? "Cast MY VELOCITY to your TV" : "Show MY VELOCITY on your TV"} data-testid="cast-site-button">
      {cfg?.app_id ? <Cast className="w-4 h-4 text-cyan-400" /> : <Tv className="w-4 h-4 text-cyan-400" />}{!compact && <span>{cfg?.app_id ? "Cast to TV" : "Show on TV"}</span>}
    </button>
  );
}
